var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawtoolsLinestring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 18.47 18.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.58.88A3,3,0,0,0,13.47.75l-.15.13a3.08,3.08,0,0,0-.74,1.23,3,3,0,0,0,.15,2.13L4.25,12.71A3,3,0,0,0,1,13.19l-.15.13a3.08,3.08,0,0,0-.74,1.23,3,3,0,0,0,3.75,3.78h0a2.8,2.8,0,0,0,1.25-.75.49.49,0,0,0,.12-.13,3,3,0,0,0,.44-3.33L14.12,5.7a3,3,0,0,0,2.21.19h0a2.92,2.92,0,0,0,1.24-.75A.8.8,0,0,0,17.71,5,3,3,0,0,0,17.58.88ZM3.72,16.16a1,1,0,0,1-1.41,0,1,1,0,0,1,0-1.41,1,1,0,0,1,.8-.29,1.09,1.09,0,0,1,.61.29,1,1,0,0,1,.28.61A1,1,0,0,1,3.72,16.16ZM16.16,3.72a1,1,0,0,1-1.41,0,1,1,0,0,1-.27-.51,1,1,0,0,1,1.68-.9,1,1,0,0,1,.28.61A1,1,0,0,1,16.16,3.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawtoolsLinestring);
export default __webpack_public_path__ + "static/media/drawtools_linestring.53299b4f445daab923ed17a781dd43ff.svg";
export { ForwardRef as ReactComponent };